import React, { useEffect, useState } from 'react';
import { ClaimInfo, ProviderClaim } from '@enter/core';
import * as S from './claim-bundle.styles';

interface ClaimBundleProps {
    bundleId: string;
    claimId: string;
    onLoadBundle: (bundleId: string) => Promise<ProviderClaim[]>;
}

export const ClaimBundle = ({ bundleId, claimId, onLoadBundle }: ClaimBundleProps) => {
    const [claims, setClaims] = useState<ClaimInfo[]>([]);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const bundleClaims = await onLoadBundle(bundleId);
                const claimData = bundleClaims.map(el => ({
                    id: el.id!,
                    chargeAmount: el.chargeAmount,
                    fromDos: el.fromDos,
                }));
                setClaims(claimData);
            } catch (error) {
                console.error('Failed to fetch bundle claims:', error);
            }
        };
        fetchData();
    }, [bundleId, claimId, onLoadBundle]);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <S.ClaimBundleRow>
            <S.ClaimsBundleBadgeWrapper
                bundleId={bundleId}
                claims={claims}
                isExpanded={isExpanded}
                onToggle={handleToggle}
            />
        </S.ClaimBundleRow>
    );
};
